// ─── Temporary Level 1 data (city-level summary) ─────────────────────────────
export const TEMP_FLEET_RANGE_DISTRIBUTION_LEVEL1_DATA = [
  {
    id: "bangalore",
    city: "Bangalore",
    certifiedRange: 20,
    excellentRange: 15,
    goodRange: 23,
    poorRange: 5,
  },
  {
    id: "mangalore",
    city: "Mangalore",
    certifiedRange: 40,
    excellentRange: 12,
    goodRange: 5,
    poorRange: 2,
  },
  {
    id: "mumbai",
    city: "Mumbai",
    certifiedRange: 30,
    excellentRange: 25,
    goodRange: 17,
    poorRange: 6,
  },
  {
    id: "surat",
    city: "Surat",
    certifiedRange: 25,
    excellentRange: 12,
    goodRange: 4,
    poorRange: 2,
  },
  {
    id: "delhi",
    city: "Delhi",
    certifiedRange: 30,
    excellentRange: 15,
    goodRange: 5,
    poorRange: 2,
  },
];

// ─── Temporary Level 2 data (vehicle-level detail) ───────────────────────────
const TEMP_VEHICLES_BY_CITY = {
  bangalore: [
    {
      id: "KA-01-AB-1234",
      licensePlateNumber: "KA-01-AB-1234",
      status: "inactive",
      certifiedRange:20,
      range:20,
      city: "Bangalore",
      state: "Karnataka",
      depot: "Bangalore Central Depot",
    },
    {
      id: "KA-01-AB-5678",
      licensePlateNumber: "KA-01-AB-5678",
      status: "active",
      certifiedRange:16,
      range:16,
      city: "Bangalore",
      state: "Karnataka",
      depot: "Bangalore North Depot",
    },
    {
      id: "KA-01-CD-1111",
      licensePlateNumber: "KA-01-CD-1111",
      status: "active",
      certifiedRange:12,
      range:12,
      city: "Bangalore",
      state: "Karnataka",
      depot: "Bangalore South Depot",
    },
  ],

  mangalore: [
    {
      id: "KA-19-AB-2222",
      licensePlateNumber: "KA-19-AB-2222",
      status: "active",
      certifiedRange:30,
      range:30,
      city: "Mangalore",
      state: "Karnataka",
      depot: "Mangalore Port Depot",
    },
    {
      id: "KA-19-CD-3333",
      licensePlateNumber: "KA-19-CD-3333",
      status: "inactive",
      certifiedRange:25,
      range:25,
      city: "Mangalore",
      state: "Karnataka",
      depot: "Mangalore City Depot",
    },
  ],

  mumbai: [
    {
      id: "MH-01-AB-4444",
      licensePlateNumber: "MH-01-AB-4444",
      status: "active",
      certifiedRange:15,
      range:15,
      city: "Mumbai",
      state: "Maharashtra",
      depot: "Mumbai Central Depot",
    },
    {
      id: "MH-01-CD-5555",
      licensePlateNumber: "MH-01-CD-5555",
      status: "active",
      certifiedRange:15,
      range:15,
      city: "Mumbai",
      state: "Maharashtra",
      depot: "Mumbai Western Depot",
    },
  ],

  surat: [
    {
      id: "GJ-05-AB-6666",
      licensePlateNumber: "GJ-05-AB-6666",
      status: "active",
      certifiedRange:10,
      range:10,
      city: "Surat",
      state: "Gujarat",
      depot: "Surat Industrial Depot",
    },
  ],

  delhi: [
    {
      id: "DL-01-AB-7777",
      licensePlateNumber: "DL-01-AB-7777",
      status: "active",
      certifiedRange:15,
      range:15,
      city: "Delhi",
      state: "Delhi",
      depot: "Delhi NCR Depot",
    },
  ],
};

// ─── Level 1 column definitions ───────────────────────────────────────────────
export const FLEET_RANGE_DISTRIBUTION_LEVEL1_COLUMN_ORDER = [
  "city",
  "certifiedRange",
  "excellentRange",
  "goodRange",
  "poorRange",
  "actions",
];

export const FLEET_RANGE_DISTRIBUTION_LEVEL1_COLUMNS_CONFIG = {
  city: {
    title: "City",
    headerLabel: "City",
    dataIndex: "city",
    key: "city",
    width: 250,
    fixed: "left",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
  },
  certifiedRange: {
    title: "Certified Range (Km/Full Charge)",
    headerLabel: "Certified Range (Km/Full Charge)",
    dataIndex: "certifiedRange",
    key: "certifiedRange",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  excellentRange: {
    title: "Vehicles With Excellent Range (Km/Full Charge)",
    headerLabel: "Vehicles With Excellent Range (Km/Full Charge)",
    dataIndex: "excellentRange",
    key: "excellentRange",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  goodRange: {
    title: "Vehicles With Good Range (Km/Full Charge)",
    headerLabel: "Vehicles With Good Range (Km/Full Charge)",
    dataIndex: "goodRange",
    key: "goodRange",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  poorRange: {
    title: "Vehicles With Poor Range (Km/Full Charge)",
    headerLabel: "Vehicles With Poor Range (Km/Full Charge)",
    dataIndex: "poorRange",
    key: "poorRange",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  actions: {
    title: "Actions",
    headerLabel: "Actions",
    dataIndex: "actions",
    key: "actions",
    valueRenderingType: "details-link",
    fixed: "right",
    width: 200,
  },
};

// ─── Level 2 column definitions ───────────────────────────────────────────────
export const FLEET_RANGE_DISTRIBUTION_LEVEL2_COLUMN_ORDER = [
  "licensePlateNumber",
  "certifiedRange",
  "range",
  "city",
  "state",
  "depot",
];

export const FLEET_RANGE_DISTRIBUTION_LEVEL2_COLUMNS_CONFIG = {
  licensePlateNumber: {
    title: "Bus Number",
    headerLabel: "Bus Number",
    dataIndex: "licensePlateNumber",
    key: "licensePlateNumber",
    valueRenderingType: "vehicle-license-plate",
    width: 250,
    fixed: "left",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
  },

  
  certifiedRange: {
    title: "Certified Range (Km/Full Charge)",
    headerLabel: "Certified Range (Km/Full Charge)",
    dataIndex: "certifiedRange",
    key: "certifiedRange",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 300,
  },
  
  range: {
    title: "Range (Km/Full Charge)",
    headerLabel: "Range (Km/Full Charge)",
    dataIndex: "range",
    key: "range",
    valueRenderingType: "number",
    sortDirections: ["ascend", "descend", "ascend"],
    sorter: true,
    width: 250,
  },
  city: {
    title: "City",
    headerLabel: "City",
    dataIndex: "city",
    key: "city",
    width: 250,
    sorter: true,
    sortDirections: ["ascend", "descend", "ascend"],
  },

  state: {
    title: "State",
    headerLabel: "State",
    dataIndex: "state",
    key: "state",
    width: 250,
    sorter: true,
    sortDirections: ["ascend", "descend", "ascend"],
  },

  depot: {
    title: "Depot",
    headerLabel: "Depot",
    dataIndex: "depot",
    key: "depot",
    width: 250,
    sorter: true,
    sortDirections: ["ascend", "descend", "ascend"],
  },
};


// ─── Data fetch functions (temporary — replace with real API calls) ────────────

export const getFleetRangeDistributionLevel1Data = async (_selectedDataPoint, _pageNumber, _sortBy) => {
  return {
    data: TEMP_FLEET_RANGE_DISTRIBUTION_LEVEL1_DATA,
    total: TEMP_FLEET_RANGE_DISTRIBUTION_LEVEL1_DATA.length,
  };
};

export const getFleetRangeDistributionLevel2Data = async (level2Record, _pageNumber, _sortBy) => {
  const cityKey = (level2Record?.city || "bangalore").toLowerCase();
  const vehicles = TEMP_VEHICLES_BY_CITY[cityKey] || TEMP_VEHICLES_BY_CITY.bangalore;
  return {
    data: vehicles,
    total: vehicles.length,
  };
};

// ─── Table config builders ────────────────────────────────────────────────────

export const getFleetRangeDistributionLevel1TableConfig = () => ({
  title: (dataPoint) =>
    `${dataPoint?.selectedItemLabel || "All"}: ${dataPoint?.project || ""}`,
  tableColumnsConfig: FLEET_RANGE_DISTRIBUTION_LEVEL1_COLUMNS_CONFIG,
  tableColumnOrder: FLEET_RANGE_DISTRIBUTION_LEVEL1_COLUMN_ORDER,
  emptyMessage: "No data available for the selected period",
});

export const getFleetRangeDistributionLevel2TableConfig = () => ({
  title: () => "Vehicles Affected",
  filters: {
    city: {
      key: "city",
      label: "City",
      displayType: "multiSelectDropdown",
      values: [
        { id: "Bangalore", value: "Bangalore" },
        { id: "Mangalore", value: "Mangalore" },
        { id: "Mumbai", value: "Mumbai" },
        { id: "Surat", value: "Surat" },
        { id: "Delhi", value: "Delhi" },
      ],
    },
    state: {
      key: "state",
      label: "State",
      displayType: "multiSelectDropdown",
      values: [
        { id: "Karnataka", value: "Karnataka" },
        { id: "Maharashtra", value: "Maharashtra" },
        { id: "Gujarat", value: "Gujarat" },
        { id: "Delhi", value: "Delhi" },
      ],
    },
  },
  tableColumnsConfig: FLEET_RANGE_DISTRIBUTION_LEVEL2_COLUMNS_CONFIG,
  tableColumnOrder: FLEET_RANGE_DISTRIBUTION_LEVEL2_COLUMN_ORDER,
  emptyMessage: "No vehicles found for the selected location",
});
